import * as Sentry from '@sentry/react'

interface ReactErrorInfo {
  componentStack?: string
}

interface SentryErrorHandlers {
  onUncaughtError: (error: unknown, errorInfo: ReactErrorInfo) => void
  onCaughtError: (error: unknown, errorInfo: ReactErrorInfo) => void
  onRecoverableError: (error: unknown, errorInfo: ReactErrorInfo) => void
}

export function createSentryErrorHandlers(): SentryErrorHandlers {
  return {
    onUncaughtError: (error: unknown, errorInfo: ReactErrorInfo) => {
      Sentry.withScope((scope) => {
        scope.setContext('errorInfo', {
          componentStack: errorInfo.componentStack,
        })
        scope.setTag('error_type', 'uncaught')
        Sentry.captureException(error)
      })
    },
    onCaughtError: (error: unknown, errorInfo: ReactErrorInfo) => {
      Sentry.withScope((scope) => {
        scope.setContext('errorInfo', {
          componentStack: errorInfo.componentStack,
        })
        scope.setTag('error_type', 'caught')
        Sentry.captureException(error)
      })
    },
    onRecoverableError: (error: unknown, errorInfo: ReactErrorInfo) => {
      Sentry.withScope((scope) => {
        scope.setContext('errorInfo', {
          componentStack: errorInfo.componentStack,
        })
        scope.setTag('error_type', 'recoverable')
        scope.setLevel('warning')
        Sentry.captureException(error)
      })
    },
  }
}
